<div class="rc-dialog">
  <div class="rc-icon">
    <span class="material-symbols-outlined">verified_user</span>
  </div>

  <h3 class="rc-title">Consent to Share Your Information</h3>

  <p class="rc-message">
    Your insurance agency would like to refer your information to Senem RFP so that
    licensed firms can prepare quotes for you.
  </p>
  <p class="rc-message">
    Do you consent to sharing your information with Senem RFP?
  </p>

  <div class="rc-actions">
    <button mat-stroked-button color="primary" type="button" class="rc-btn-outline" (click)="decline()">
      No, Cancel
    </button>
    <button mat-flat-button color="primary" type="button" class="rc-btn-solid" (click)="agree()">
      Yes, I Consent
    </button>
  </div>
</div>
